import { AppEnvironment, environment as common } from '@env/environment.common';

export const environment: AppEnvironment = {
  production: true,
  name: 'staging',
  default: 'preorders',
  features: {
    ...common.features
  },
  values: {
    ...common.values,
    stripePublishKey: 'pk_test_51RMP0CPu4DL4LUPyZjhR0V3W6Fer6XpM0gRwA5EmCIAQHpIi9dxNdHganXPPsXKMAcyznpnTSALM4QIypObuoror00mznRksD3',
    dwspayPublishKey: 'pk_test_51SypacQ0w9MN8n1XTiNfWdmQwfDXfg7VX87YsfWVoaVK15LYcI6oUyPEjSp3ilZY7CQ0AZh1Vw5uSXXVvSmI5zZn00MF5RgvBm',
    stripePaymentMethodConfiguration: 'pmc_1QmILXLCrn2DvYMpculFLE7w',
  },
  hosts: {
    preorders: {
      ...common.hosts.preorders,
      host: 'api.preorders-staging.divinea.com',
      protocol: 'https',
      port: '',
    }, 
    ws: {
      ...common.hosts.ws,
      host: 'api-crm-staging.divinea.com',
      protocol: 'https',
      port: '',
    },
    wspayments: {
      ...common.hosts.wspayments,
      host: 'api-staging.divinea.com',
      protocol: 'https',
      port: '',
    }
  }
};
